const ProjectRoles = {
  id: "projectRoles",
  label: "Project Roles",
  endpoint: "roles/project",
  responseBodyKey: "roles",
  columnConfig: [
    {
      field: "name",
      headerName: "Project Role",
      width: 250,
      description: "Project Role",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default ProjectRoles;
